import React, { ComponentType, ReactNode } from 'react'

import { getColorBasedMode } from '@application/Interfaces/Features/Header/utils'
import { useTranslation } from '@application/Interfaces/Hooks/useTranslation'
import { ArrowIcon } from '@application/Interfaces/Icons'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { MenuButtonProps } from '@icontainers/design-system/dist/organisms/DropdownMenu'
import { HeaderThemeModeType } from '@src/Application/Types/ComponentTypes'

import { Button, SelectedLanguage } from './LanguageButton.styled'

export type LanguageButtonProps = MenuButtonProps & {
    currentLanguage: ReactNode
    mode: HeaderThemeModeType
}

export const LanguageButton: ComponentType<LanguageButtonProps> = ({ onClick, isOpen, currentLanguage, mode }) => {
    const { t } = useTranslation()

    return (
        <Button onClick={onClick} role="button" sc={{ isOpen }} className={mode}>
            <Grid container alignItems="center">
                <SelectedLanguage aria-label={t('language.selected')}>{`${currentLanguage}`}</SelectedLanguage>
                <ArrowIcon direction={isOpen ? 'up' : 'down'} colorCode={getColorBasedMode(mode)} />
            </Grid>
        </Button>
    )
}
